import { render } from "./ConfigMgmt.vue?vue&type=template&id=b10691e2"
import script from "./ConfigMgmt.vue?vue&type=script&lang=js"
export * from "./ConfigMgmt.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script